import { render, staticRenderFns } from "./HealthHabitsQuestionList.vue?vue&type=template&id=593804cb&scoped=true"
import script from "./HealthHabitsQuestionList.vue?vue&type=script&lang=js"
export * from "./HealthHabitsQuestionList.vue?vue&type=script&lang=js"
import style0 from "./HealthHabitsQuestionList.vue?vue&type=style&index=0&id=593804cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593804cb",
  null
  
)

/* custom blocks */
import block0 from "./HealthHabitsQuestionList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports